import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormLabel,
  Image,
  Input,
  InputGroup,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import Effects from '../../../components/Effects/Effects';
import { IoLogoGoogle } from 'react-icons/io';
import { IMG } from './../../../Content/Content';
import { Link } from 'react-router-dom';
import Footer from '../../../components/Header/Footer';
import Header from '../../../components/Header/Header';

const Login = () => {
  return (
    <VStack>
      <Header/>
      <VStack
        className="login"
        bg="#fff"
        paddingY="200px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <VStack
          w="1259px"
          mx="auto"
          bg="#F5F5F5"
          boxShadow="0px 4px 4px 4px rgba(0, 0, 0, 0.25)"
          borderRadius="19px"
          h="auto"
          padding="50px"
        >
          {/* Form */}
          <Box w="50%" margin="auto" textAlign="center">
            {/* title */}
            <Box className="form">
              <Box className="top-bar">
                <Text
                  className="title"
                  fontSize="50px"
                  fontFamily={'Poppins, sans-serif'}
                  fontWeight={'600'}
                  lineHeight="75px"
                  color="rgba(0, 0, 0, 0.86)"
                >
                  Glad to see you!
                </Text>
                <Text
                  fontSize="20px"
                  className="sub-title"
                  fontFamily={'Poppins, sans-serif'}
                  fontWeight={'500'}
                  lineHeight="30px"
                  color="rgba(0, 0, 0, 0.86)"
                >
                  Please enter details to continue
                </Text>
              </Box>

              <form>
                <InputGroup
                  marginBottom="2rem"
                  marginTop="2rem"
                  display={'flex'}
                  flexDirection={'column'}
                >
                  <FormLabel
                    for="Email"
                    display={'block'}
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.86)"
                  >
                    Email
                  </FormLabel>
                  <Input
                    type="text"
                    id="Email"
                    name="Email"
                    border="0"
                    borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                    bg="transparent"
                    paddingY={'10px'}
                    h="40px"
                    _focusVisible={{ boxShadow: 'none' }}
                    display={'block'}
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.86)"
                  />
                </InputGroup>

                <InputGroup
                  marginBottom="2rem"
                  marginTop="2rem"
                  display={'flex'}
                  flexDirection={'column'}
                >
                  <FormLabel
                    for="password"
                    display={'block'}
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.86)"
                  >
                    Password
                  </FormLabel>
                  <Input
                    type="password"
                    id="password"
                    name="password"
                    border="0"
                    borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                    bg="transparent"
                    paddingY={'10px'}
                    h="40px"
                    _focusVisible={{ boxShadow: 'none' }}
                    display={'block'}
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.86)"
                  />
                </InputGroup>
                <InputGroup
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box className="rememberMe">
                    <Checkbox
                      colorScheme=" linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);"
                      defaultChecked
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Remember me
                    </Checkbox>
                  </Box>
                  <Box className="forgot-password">
                    <Button
                      type="Button"
                      bg="transparent"
                      _hover={{ background: 'transparent' }}
                      padding={'0'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Forget password
                    </Button>
                  </Box>
                </InputGroup>

                <Box>
                  <Button
                    type="submit"
                    bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);"
                    boxShadow={'-2px -6px 3px rgba(0, 0, 0, 0.25)'}
                    borderRadius={'15px'}
                    fontSize={'30px'}
                    fontWeight={'500'}
                    letterSpacing={'-1.13533px'}
                    color="#F5F3EE"
                    display="block"
                    width="100%"
                    paddingY="10px"
                    marginTop="20px"
                    height="auto"
                    _hover={{
                      background:
                        'linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)',
                    }}
                  >
                    Log in
                  </Button>
                </Box>
              </form>

              <Stack paddingY="25px">
                {/* Top  */}
                <Box display="flex" alignItems="center">
                  <Divider border="2px solid rgba(0, 0, 0, 0.28)" />
                  <Text
                    paddingX="4px"
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.86)"
                  >
                    OR
                  </Text>
                  <Divider border="2px solid rgba(0, 0, 0, 0.28)" />
                </Box>
              </Stack>

              <Stack>
                <Button
                  type="button"
                  display="flex"
                  justifyContent="space-between"
                  padding="10px 25px"
                  h="auto"
                  background="#F7F7F7"
                  boxShadow="-2px 4px 3px rgba(0, 0, 0, 0.25)"
                  borderRadius="15px"
                  marginBottom="10px !important"
                >
                  <Text
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'400'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.77)"
                  >
                    Login with Google
                  </Text>
                  <Image src={IMG.google} maxWidth="100%" w="25px" />
                </Button>

                {/* login with facebook */}

                <Button
                  type="button"
                  display="flex"
                  justifyContent="space-between"
                  padding="10px 25px"
                  h="auto"
                  background="#F7F7F7"
                  boxShadow="-2px 4px 3px rgba(0, 0, 0, 0.25)"
                  borderRadius="15px"
                  marginBottom="10px !important"
                >
                  <Text
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'400'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.77)"
                  >
                    Login with Facebook
                  </Text>
                  <Image src={IMG.facebook} maxWidth="100%" w="25px" />
                </Button>

                {/* login with facebook */}

                <Button
                  type="button"
                  display="flex"
                  justifyContent="space-between"
                  padding="10px 25px"
                  h="auto"
                  background="#F7F7F7"
                  boxShadow="-2px 4px 3px rgba(0, 0, 0, 0.25)"
                  borderRadius="15px"
                  marginTop="10px !important"
                >
                  <Text
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'400'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.77)"
                  >
                    Login with Apple
                  </Text>
                  <Image src={IMG.apple} maxWidth="100%" w="25px" />
                </Button>

                <Box display="flex" justifyContent="end" alignItems="center">
                  <Text
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.77)"
                    marginRight="2px"
                  >
                    Don’t have account?{' '}
                  </Text>
                  <Link to="/register" color="#f6a15d" className="register">
                    {' '}
                    Register now
                  </Link>
                </Box>
              </Stack>
            </Box>
          </Box>
        </VStack>

        {/* <Effects bg="#F69963" bottom="0" left="0"/>
                <Effects bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);" bottom="0" left="0"/>
                <Effects bg="#F69963" bottom="0" left="0"/> */}
      </VStack>

      <Footer className="w-100"/>
    </VStack>
    
)}

export default Login;
